import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { i18n, mediaQuery } from "src/common";
import { Flex } from "src/components";
import { footer, header } from "src/theme";
import React from "react";

const rotate = keyframes`
  0%, 100%  { fill: #6A0098; }
  25%       { fill: #E1CCEA; }
  50%       { fill: #470066; }
  75%       { fill: #F2EAF7; }
`;

const AnimatedSvg = styled.svg<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  rect:nth-of-type(1) { animation: ${rotate} 2s ease-in-out infinite; }
  rect:nth-of-type(2) { animation: ${rotate} 2s ease-in-out infinite -0.3s; }
  rect:nth-of-type(3) { animation: ${rotate} 2s ease-in-out infinite -0.9s; }
  rect:nth-of-type(4) { animation: ${rotate} 2s ease-in-out infinite -0.6s; }
`;

const FlexStyle = styled(Flex)<{ page: boolean; overlay: boolean }>`
  ${({ page, overlay }) => overlay ? `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 1000;
  ` : `
    min-height: ${page ? `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)` : 'auto'};
    @media ${mediaQuery('mobile')} {
      min-height: ${page ? `calc(100vh - ${footer.height + header.mobileHeight + 80}px)` : 'auto'};
    }
    @media ${mediaQuery('laptopL')} {
      min-height: ${page ? `calc(100vh - ${footer.height + header.height + 80}px)` : 'auto'};
    }
  `}
`;

interface LoaderProps {
  size?: number;
  page?: boolean;
  loading?: boolean;
  overlay?: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ 
  size = 60, 
  page = false, 
  loading = true,
  overlay = false,
}) => (
  loading ? (
    <FlexStyle 
      justify="center" 
      align="center" 
      page={page}
      overlay={overlay}
    >
      <AnimatedSvg size={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={i18n.t('common.loading')}>
        <rect x="25" y="25" width="24" height="24" rx="4" />
        <rect x="25" y="53" width="24" height="24" rx="4" />
        <rect x="53" y="25" width="24" height="24" rx="4" />
        <rect x="53" y="53" width="24" height="24" rx="4" />
      </AnimatedSvg>
    </FlexStyle>
  ) : null
)
